var AT_Main = {

	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE 
			myWidth = window.innerWidth;
		} 
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
			//IE 6+ in 'standards compliant mode' 
			myWidth = document.documentElement.clientWidth; 
		} 
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
			//IE 4 compatible 
			myWidth = document.body.clientWidth;  
		}

		return myWidth;
	}
	
	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .visible-xs-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .visible-sm-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .visible-md-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .visible-lg-block").css("display") == "block")
			return 4; //desktop layout
	}
  
	,homeSlideshow : function(parallax_scrolling, parallax_hover){ 

		// setTimeout(function() { 
			var __this = this;
	        __this.parallax_scrolling = parallax_scrolling || false;
	        __this.parallax_hover = parallax_hover || false;
	        if(jQuery('.home-slideshow-wrapper').length){
	            jQuery('.home-slideshow-wrapper').each(function(index,value){
	              
	                var _delay_time = '';
	                if(jQuery(value).data('autoplay')){
	                	_delay_time = jQuery(value).data('time');
	                }
	              
	                var swiper = new Swiper('.swiper-container', {
	                  	autoplay: _delay_time
	                  	// ,autoHeight: true
	                  	,loop: true
	                    ,pagination: '.swiper-pagination'
	                    ,paginationClickable: '.swiper-pagination'
	                    ,nextButton: '.swiper-button-next'
	                    ,prevButton: '.swiper-button-prev'
	                    //,spaceBetween: 30
	                    ,scrollbarDraggable: true
	                    ,effect: jQuery(value).data('animation')
	                  	,setWrapperSize: false
	                    ,onImagesReady: function(swiper) {
	                        var slideH = $(swiper.container[0]).find('.swiper-slide  img').height(),
								slideW = $(swiper.container[0]).find('.swiper-slide  img').width();
								
								$(swiper.container[0]).find('.swiper-slide > img').css('visibility', 'hidden');
								$(swiper.container[0]).find('.swiper-slide').each(function() {
								var _this = $(this);
								
								//resize video full slide
								_this.find('.video-slide').show();
								if(_this.find('.video-slide video').length){
									var videoH =_this.find('.video-slide video').height();
									var videoW =_this.find('.video-slide video').width();
									var ratio=slideH/videoH;
		
									if((videoW * ratio)>slideW){
										_this.find('.video-slide video').css({
											width: 'auto',
											height: '100%',
										});	
									}
									if((videoW * ratio)<slideW){
										_this.find('.video-slide video').css({
											width: '100%',
											height: 'auto',
										});	
									}	
								}
								//end resize video
								

	                            _this.find('.video-slide video').css({
	                                left: '50%',
	                                top: '50%',
	                                transform: 'translate(-50%,-50%)'
	                          	});	
	                          
							});

							if(!$('.header-wrapper').hasClass('style-4')){
								__this.slideshowParallax();
							}
							
	                    } 
	                    ,onSlideChangeStart: function (s) {
							$('.swiper-container').css({
							    height: s.slides.eq(s.activeIndex).height()
							})
						}
	                });
	            });
	        }
	    // },500)    
    }
  	
  	,home_4_slideShow : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                	_delay_time = jQuery(value).data('time');
                }
              
                var swiper = new Swiper('.swiper-container', {
                  	autoplay: _delay_time
                  	,loop: true
                    ,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    //,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: jQuery(value).data('animation')
                  	,setWrapperSize: false
                    ,onImagesReady: function(swiper){
						
                    	var slideH = $(swiper.container[0]).find('.swiper-slide  img').height(),
							slideW = $(swiper.container[0]).find('.swiper-slide  img').width();
							  

                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
						  var _this = $(this);
						  _this.find('.video-slide').show();
							if(_this.find('.video-slide video').length){
								
								var videoH =_this.find('.video-slide video').height();
								var videoW =_this.find('.video-slide video').width();
								var ratio=slideH/videoH;
								if((videoW * ratio)>slideW){
									_this.find('.video-slide video').css({
										width: 'auto',
										height: '100%',
									});	
								}
								if((videoW * ratio)<slideW){
									_this.find('.video-slide video').css({
										width: '100%',
										height: 'auto',
									});	
								}	
							}
						  

                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                        });
                    }
                });
            });
        }
    }	

  	,homeIE : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                  _delay_time = jQuery(value).data('time');
                }
              
                var swiper = new Swiper('.swiper-container', {
                    autoplay: _delay_time
                    // ,autoHeight: true
                  	,loop: true
                  	,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: 'fade'
                  	,setWrapperSize: true
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                          
                        });
                    }
                    ,onSlideChangeStart: function (s) {
						$('.swiper-container').css({
						    height: s.slides.eq(s.activeIndex).height()
						})
					}
                });
            });
        }
    }
	
	,stickMenu : function() {
		if(!($('.header-wrapper').hasClass('style-4'))) {
			var enable_stick = jQuery(".header-content").data('stick');
			if(enable_stick){
			  //Keep track of last scroll
				var lastScroll = 0;
				var header = jQuery(".header-container");
				var body_content = jQuery("#body-content");
				var bt=$(header).height();
				jQuery(window).scroll(function() {
					//Sets the current scroll position
					var st = jQuery(this).scrollTop();
			
					//Determines up-or-down scrolling
					if (st > lastScroll) {
						
						//Replace this with your function call for downward-scrolling
						if (st >= bt ) {
							header.addClass("header-fixed fadeInDown animated");
							body_content.addClass("has-header-fixed");
						}
					}
					else {
						//Replace this with your function call for upward-scrolling
						if (st < bt) {
							header.removeClass("header-fixed fadeInDown animated");
							body_content.removeClass("has-header-fixed");
						}
					}
					//Updates scroll position
					lastScroll = st;
				});
			}
		}
	}
	
	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) { 
				var d = b + c / 2;
			}
			else { 
				var d = 1 ;
			}

			if (d < 1000 && d < c) { 
				jQuery("#scroll-to-top").removeClass('on off').addClass('off'); 
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on'); 
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}

	,mailchipPopup : function(){
		var expire = jQuery("#mailchimp-popup").data('expires');
		if (jQuery.cookie('mycookie')) {
			//it hasn't been one days yet
		}
		else {
          setTimeout(function(){
            jQuery.fancybox(
				jQuery('#mailchimp-popup'),
				{
					'autoDimensions': false
					,'width'		: 770
					,'height'		: 400
					,'autoSize' 	: false
					,'transitionIn'	: 'none'
					,'transitionOut': 'none'

				}
			);
          }, 30000);
		}
		jQuery.cookie('mycookie', 'true', { expires: expire });
	}
  
  	,toggleCartSidebar : function(){
		jQuery('.cart-toggle').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.cart-sb').toggleClass('opened');
			jQuery('body').toggleClass('cart-opened');
		});

		jQuery('#page-body, .c-close').on('click',function () {
			jQuery('.cart-sb').removeClass('opened');
			jQuery('html,body').removeClass('cart-opened');
          
            jQuery(".dropdown").removeClass("menu-mobile-open");
          
			AT_Main.fixReturnScroll();
		}); 	
	}
  
  	,toggleFOFSidebar : function(){
		jQuery('.filter-of-icon').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.filter-order-form').toggleClass('opened');
			jQuery('body').toggleClass('f-sidebar-opened');
		});

		jQuery('#page-body').on('click',function () {
          	jQuery('.filter-order-form').removeClass('opened');
			jQuery('html,body').removeClass('f-sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
      
      	jQuery('.fof-close').on('click',function () {
          	jQuery('.filter-order-form').removeClass('opened');
			jQuery('html,body').removeClass('f-sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
	}
  
  	,toggleFilterSidebar : function(){
      
      	jQuery('.mobile-filter').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('#sidebar').toggleClass('opened');
			jQuery('body').toggleClass('sidebar-opened');
		});

		jQuery('#page-body').on('click',function () {
          	jQuery('#sidebar').removeClass('opened');
			jQuery('html,body').removeClass('sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
      
      	jQuery('.f-close').on('click',function () {
          	jQuery('#sidebar').removeClass('opened');
			jQuery('html,body').removeClass('sidebar-opened');
			AT_Main.fixReturnScroll();
		});
	}
  
  	,toggleFilterNoneSidebar : function(){
		jQuery('.filter-icon').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.filter-sidebar').toggleClass('opened');
			jQuery('body').toggleClass('filter-sidebar-opened');
		});

		jQuery('#page-body').on('click',function () {
          	jQuery('.filter-sidebar').removeClass('opened');
			jQuery('html,body').removeClass('filter-sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
      
      	jQuery('.fsb-close').on('click',function () {
          	jQuery('.filter-sidebar').removeClass('opened');
			jQuery('html,body').removeClass('filter-sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
	}

	,
    slideshowParallax: function() { // Init Slideshow with parallax Scrolling
        var _this = this;
        jQuery(window).off('scroll.parallax').on('scroll.parallax', function(){
            _this.updateSlideshowParallax();
        });
    }
 

    ,
    
    updateSlideshowParallax: function() {     
        var pos = $(window).scrollTop();
        var elem = $('.slideshow-catalog-wrapper');
        var top = elem.offset().top;
		var elemH = elem.height();
		var windowHeight = $(window).height();

        if (pos>top + elemH||pos<top||top > pos + windowHeight) {
			$('.swiper-slide').each(function(){
				$('.swiper-slide').css('transform', 'translateY(0px)');
			
			})
            return;  
		}
		
		$('.swiper-slide').each(function(){
				$('.swiper-slide').css('transform', 'translateY(' + Math.round((pos-top) * 0.35) + 'px)');
			
		})
		
        
    }
  
    ,parallaxIt: function() {
        if ($(".parallax-section").length == 0)
            return;
        $.fn.parallaxScroll = function(xpos, speedFactor, outerHeight) {
            var elem = $(this);
            var getHeight;
            var firstTop;
            var paddingTop = 0;

            //get the starting position of each element to have parallax applied to it      
            $(this).each(function() {
                firstTop = $(this).offset().top;
            });

            getHeight = function(jqo) {
                return jqo.outerHeight(true);
            };

            var j$element, top, height, pos;

            function update() {

                pos = $(window).scrollTop();
                firstTop = elem.offset().top;
                height = getHeight(elem);

                if (pos + $(window).height() < firstTop || pos > firstTop + height) {
                    return;
                }

                if (AT_Main.checkLayout() != 1)
                    elem.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px", 0);
                else
                    elem.css('backgroundPosition', xpos + " " + -Math.round((firstTop - pos) * speedFactor) + "px", 0);
            }

            window.addEventListener('scroll', function() {
                update();
            }, false)

            update();
        };

        $(".parallax-section").parallaxScroll("50%", 0.1);
    }
      
    ,handleGridList : function(){
        jQuery('.grid-list a').click(function(t){
          t.preventDefault();
          var e = $(this),
              a = e.attr("href");
          Shopify.queryParams.view = a;
          location.search = jQuery.param(Shopify.queryParams);
        })
    }
  
    ,handleOrderFormQty : function(){
      jQuery("body").on("click",".global-product-info-qty-plus",function(){
        q = $(this).prev();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 0 : value;
        value++;
        q.val(value);
      });

      jQuery("body").on("click",".global-product-info-qty-minus",function(){
        q = $(this).next();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 1 : value;
        if(value > 0)
        {
          value--;
          q.val(value);
        }
      });
    }

    ,subHandleOrderFormQty : function(plus, q, minus){
      jQuery("body").on("click", plus ,function(){
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 0 : value;
        value++;
        q.val(value);
      });

      jQuery("body").on("click", minus,function(){
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 1 : value;
        if(value > 0)
        {
          value--;
          q.val(value);
        }
      });
    }
  
  	,handleShowBy : function(){
        jQuery('.show-by #show_by_box a').click(function(t){
            t.preventDefault();
            var e = $(this),
                a = e.attr("href");
            Shopify.queryParams.view = a;
            location.search = jQuery.param(Shopify.queryParams);
        })
    }
  
  	,effectNavigation : function(){ // Make hover effect of navigation
		/*jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInUp animated");
		});*/
      
      	jQuery(".top-account-holder").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      	
      	if (window.matchMedia("(min-width: 992px)").matches) {
      		jQuery(".currency-block").hover(function(e){
				jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
			},function(e){
				jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
			});
      	}
      
      	jQuery(document).on('click','.searchbox>a',function(e){
            $(this).parents().find('.searchbox').toggleClass('open');
  		});
      
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', ''); 
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }
  
  	,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }
    
	,menuOnMobile : function(){
		jQuery('#page-body').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});
      
      	jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','[data-toggle=offcanvas]',function(e){
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery(".menu-mobile").toggleClass("opened");
			jQuery("html,body").toggleClass("menu-opened")
		});

		jQuery(".navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

		jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
			
            if (e.hasClass("menu-mobile-open")) {
                e.removeClass("menu-mobile-open");
                $(this).find('.visible-xs').removeClass('fa-minus');
                $(this).find('.visible-xs').addClass('fa-plus');
            } else {
                e.addClass("menu-mobile-open");
              	$(this).find('.visible-xs').removeClass('fa-plus');
                $(this).find('.visible-xs').addClass('fa-minus');
			}
			
		});
		$("body:not(.menu-mobile)").click(function(){
			$(this).find('.mobile-version .menu-mobile .main-nav .expand .visible-xs').removeClass('fa-minus');
			$(this).find('.mobile-version .menu-mobile .main-nav .expand .visible-xs').addClass('fa-plus');	
		});
	
      
	}
	
	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{       
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}
  
  	,lookbooks_initor : function(){ 
		if( jQuery('.bc-lookbooks.lookbooks.margin-row').length > 0 ){
		  
			if( 'undefined' === typeof Isotope ){
				console.log(" Isotope has not defined yet! ");
				return;
			}

			jQuery('.bc-lookbooks.lookbooks.margin-row').isotope({
			  itemSelector: '.look-item',
			  layoutMode: 'fitRows'
			});
		}
		if( jQuery('.bc-lookbooks.lookbooks.look-slider').length > 0 ){
		  
			if( 'undefined' === typeof Swiper ){
				console.log(" Swiper has not defined yet! ");
				return;
			}
          
          	$('body').addClass('carousel-lookbook');

            var swiper_look = new Swiper('.lookbooks-wrapper.look-slider', {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev', 
                pagination: '.swiper-pagination',
                paginationType: 'progress',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 30
            });
		}      
	}
  
    ,callPriceSlider: function() {
      if( $('#range-slider').length <= 0 ){
      	return;
      }
      
        var _min_price = jQuery('#amount > span.min-val > span.money').html()
        	,_min_price =_min_price.replace(/[^0-9\.]+/g,"")
            ,_min_price = _min_price.match(/\d+(\.\d+)?/g,"")
            ,_max_price = jQuery('#amount > span.max-val > span.money').html()
            ,_max_price =_max_price.replace(/[^0-9\.]+/g,"")
            ,_max_price = _max_price.match(/\d+(\.\d+)?/g,"");
      
        if( _min_price.length <= 0 || _max_price <= 0 ){
          return;
        }else{
           _min_price = Number(_min_price[0]);
           _max_price = Number(_max_price[0]);
        }
      
        $('#range-slider').slider({
            range: true,
            min: _min_price,
            max: _max_price,
            values: [_min_price, _max_price],
            create: function() {
              //Currency.convertAll('USD', Currency.currentCurrency); 
              // $("#amount").html('<span class="min-val"><span class="money">$10.00</span></span> - <span class="max-val"><span class="money">30000.00</span></span>');
            },
            slide: function (event, ui) {
              $("#amount").html('<span class="min-val">' + Shopify.formatMoney(ui.values[0]*100,_bc_config.money_format) + '</span><span class="max-val">' + Shopify.formatMoney(ui.values[1]*100,_bc_config.money_format) + '</span>');
              Currency.convertAll('USD' , Currency.currentCurrency);
              var mi = ui.values[0];
              var mx = ui.values[1];
              filterSystem(mi, mx);
            }
        })


        function filterSystem(minPrice, maxPrice) {
          $(".cata-product .product-price-range").hide().filter(function () {
            var price = parseInt($(this).data("price"), 10);
            return price >= minPrice && price <= maxPrice;
          }).show();
        }

    }
	
	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
	}

	,filterCatalogReplace : function(){
		var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
		var val = value.substring(value.lastIndexOf('?')); 

		collectionUrl = collectionUrl.replace(value, '');

		value = value.replace(val, '');
		value = value.replace('#', '');

		var value_arr = value.split('+');

		var current_arr = [];
		jQuery('#'+filter_id+' li.active-filter').each( function() {
		  current_arr.push(jQuery(this).attr('data-handle'));
		});

		jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
		jQuery('#'+filter_id+' li').removeClass('active-filter');

		for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
		  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
		}

		var new_data = value_arr.join('+')

		var new_url = collectionUrl+new_data+val;

		window.location = new_url;
	}
  
	,filterCatalog : function(){
		var currentTags = ''
			,filters 	= jQuery('.advanced-filter');

		filters.each(function() {
			var el = jQuery(this)
				,group = el.data('group');

			if ( el.hasClass('active-filter') ) { //Remove class hidden
				el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
			}
		});

		filters.on('click', function() {
			var el 		= jQuery(this)
				,group 	= el.data('group')
				,url 	= el.find('a').attr('href');

			// Continue as normal if we're clicking on the active link
			if ( el.hasClass('active-filter') ) {
				return;
			}
		});

		jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

			var filter_id = jQuery(this).attr('id');
			filter_id = filter_id.replace('clear-', '');

			var collectionUrl = window.location.href;

			if(collectionUrl.match(/\?/)){
				var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

				if(string.match(/\//)){
					var str_replace = string.replace(/\//, '');
					collectionUrl = collectionUrl.replace(string, '');
					collectionUrl = collectionUrl+str_replace;
					AT_Main.filterCatalogReplace();
				}
				else{
					AT_Main.filterCatalogReplace();
				}
			}
			else{
				var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

				collectionUrl = collectionUrl.replace(value, '');  

				value = value.replace('#', '');

				var value_arr = value.split('+');

				var current_arr = [];
				jQuery('#'+filter_id+' li.active-filter').each( function() {
				  current_arr.push(jQuery(this).attr('data-handle'));
				});

				jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
				jQuery('#'+filter_id+' li').removeClass('active-filter');

				for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
				  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
				}

				var new_data = value_arr.join('+')

				var new_url = collectionUrl+new_data;

				window.location = new_url;
			}

		});
	}
	
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
  	}

	,refreshImage : function(){ // Update product image in detail page
		if(jQuery('#gallery-image').length){

			jQuery('#product-image').on('click', '.thumb-img', function() {

				var _$this = jQuery(this);

				if(!_$this.hasClass('active')){
					var parent = _$this.parents('.product-image-inner');
					var src_original = _$this.attr('data-zoom-image');
					var src_display = _$this.attr('data-image');

					parent.find('.thumb-img').removeClass('active');
					_$this.addClass('active');

					parent.find('.featured-image').find('img').attr('data-zoom-image', src_original);
                 	parent.find('.featured-image').find('img').attr('src', src_display);
				}

				return false;
			});
		}
	}
  
  	,switchImgProduct: function() {
    	$('.product-wrapper .swatch-element > input').on('change', function(e){
    		console.log('abc')
          	e.stopPropagation();
          	var imgUrl = $(this).data("swatch-image"),
                parent = $(this).parents('.product-wrapper'),
                imgElem = parent.find('.product-image img');
          	imgElem.parents('.product-image').addClass('img-loading');
          	imgElem.attr('src', imgUrl)
          	var fakeImg = new Image();
          	fakeImg.src = imgUrl;
            fakeImg.onload = function(event){
                imgElem.parents('.product-image').removeClass('img-loading');
            };
            fakeImg.onerror = function() {
                //Code for error loading
                console.log('err')
            };
        });
    }

	,refreshZoom : function(){ // Update Zoom in detail page
		var enable_zoom = jQuery('.featured-image').data('zoom');
		if((jQuery('.elevatezoom').length)){

			var zoomImage = jQuery('.elevatezoom .zoom-image');

			zoomImage.elevateZoom({
				gallery				:'gallery-image' 
				,galleryActiveClass	: 'active'
                ,zoomType			: 'lens'
                ,cursor				: 'pointer'
                ,lensShape 			: "round"
                ,lensSize 			: 300
			});

			//pass the images to Fancybox
          	jQuery(".elevatezoom").bind("click", function(e) {  
				var ez =   jQuery('.elevatezoom .zoom-image').data('elevateZoom'); 
				jQuery.fancybox(ez.getGalleryList(),{
					closeBtn  : false,
					helpers : {
						buttons : {}
					}
				});
				return false;
			});
		}

	}
  
  	,scareName : function(){
        var _name_height = 0;
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').each(function( index,value ){
          _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
        });
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').css('height',_name_height);
    }        
  
  	,scareWidth : function(){
        var _name_width = 110;
        jQuery('.variants-wrapper .selector-wrapper').find('label').each(function( index,value ){
          _name_width = jQuery(value).width() > _name_width ? jQuery(value).outerWidth() : _name_width;
        });
        jQuery('.variants-wrapper .selector-wrapper').find('label').css('width',_name_width);
      	jQuery('.swatch.size').find('.header').css('width',_name_width);
      	jQuery('.swatch.color, .swatch.colour').find('.header').css('width',_name_width);
      	jQuery('.product-code span:first-child').css('width',_name_width);
      	jQuery('.product-qty, .quantity').find('label').css('width',_name_width);
    }       
  
    ,scareScreen : function(){
      	if( typeof _bc_config == "undefined" ){
          	return;
      	}
      	var _current = this;
      
      	if( _bc_config.enable_title_blance == "true" ){
          	this.scareName();
      	}      
      	
      	jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }  
        });  
    }

	,cartJS_handle : function() {
		//Bind cart json data to HTML
		//rivets.bind(jQuery('.templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content'), {cart: CartJS.cart});
		//It's need to calculate from default currency to current currency that has chosen before 

          if( _bc_config.show_multiple_currencies == 'true' ){
            setTimeout(function(){
            	Currency.convertAll('USD' , Currency.currentCurrency); 
            },50);                        
          }

		//Handle when update to cart json completed
		jQuery(document).on('cart.requestComplete', function(event, cart) {
			Shopify.onCartUpdate(CartJS.cart);
            if( _bc_config.show_multiple_currencies == 'true' ){  
				Currency.convertAll('USD' , Currency.currentCurrency); 
            }                        
		});
	}
              
    ,instagram_listener : function(){
		if( jQuery('#instagram_list_2').length > 0 ){
		  
			if( 'undefined' === typeof Instafeed ){
				console.log(" Instafeed has not defined yet! ");
				return;
			}
		  
			var instagram_list;
			jQuery('#instagram_list_2').each(function( index,value ){
				instagram_list = new Instafeed({
					get: "user"
					,target		: "instagram_list_2"
					,accessToken	: jQuery(value).data('token-key')
					,userId		: jQuery(value).data('uid')
					//,clientId	: $(value).data('cid')
					,limit		: jQuery(value).data('limit')
                    ,resolution : "low_resolution"
                    ,resolution2 : "standard_resolution"
                  	,after: function() {
						jQuery("#instagram_list_2 > a").each(function(index,value){
                          	jQuery(value).attr("target","_blank");
						}); 	
					}
			});
			instagram_list.run();
		  });
		  
		}		
	}

	,productSlider : function(){
	    var bxMode;
	    var elm = $('.bxslider');
	    var bxWrapperWidth = $('.more-view-image').width() + 15
	    var sliderW, sliderMargin, sliderNumber;

	    if (window.matchMedia("(max-width: 767px)").matches) {
	      sliderW = (bxWrapperWidth / 4) - 15;
	      bxMode = 'horizontal';
	      sliderMargin = 15;
	      sliderNumber = 3;
	    } else {
	      sliderW = bxWrapperWidth;
	      bxMode = 'vertical';
	      sliderMargin = 30;
	      sliderNumber = 3;
	    }

	    window.productThumbSlider = elm.bxSlider({
	        mode: bxMode,
	        slideMargin: sliderMargin,
	        infiniteLoop:false,
	        minSlides:sliderNumber,
	        maxSlides:sliderNumber,
	        pager:false,
	        slideWidth: sliderW,
	        prevText:'<i class="ion-ios-arrow-up" title="Previous"></i>',
	        nextText:'<i class="ion-ios-arrow-down" title="Next"></i>',
	    })    
	}

  	,paddingBottomProductImage : function(){
    	if (window.matchMedia("(max-width: 767px)").matches){
      		var sliderH = $('.more-view-image').height()
      		$('#product-image').css('padding-bottom', sliderH)
    	}
    	else {
      		$('#product-image').css('padding-bottom', '0')
    	}
  	}

  	,countdown: function(date){

	    var x = setInterval(function() {
		    var now = new Date().getTime();

		    if (date > now) {
		        var distance = date - now;

		        // Time calculations for days, hours, minutes and seconds
		        var days 	= Math.floor(distance / (1000 * 60 * 60 * 24));
		        var hours 	= Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

		        // Display the result in respective elements
		        document.getElementById("day_number").innerHTML 	= days;
		        document.getElementById("hour_number").innerHTML 	= hours;
		        document.getElementById("min_number").innerHTML 	= minutes;
		        document.getElementById("sec_number").innerHTML 	= seconds;

		        var thisSec 	= $("#sec");
		        var currentSec 	= Math.floor((seconds + 35 * 60 / 365) * 365 / 60);

		        var thisMin 	= $("#min");
		        var currentMin 	= Math.floor((minutes + 35 * 60 / 365) * 365 / 60);

		        var thisHour 	= $("#hour");
		        var currentHour = (hours + 35 * 24 / 365) * 365 / 24;

		        var thisDay 	= $("#day");
		        var currentDay 	= 35 + days;

		        function update(id, currentNo) {
		          id.css("stroke-dashoffset", currentNo);
		        }

		        if (days < 366) {
		          update(thisSec, currentSec);
		          update(thisMin, currentMin);
		          update(thisHour, currentHour);
		          update(thisDay, currentDay);
		        }
		    } else {
		    	// document.getElementById("day_number").innerHTML 	= 0;
		     //    document.getElementById("hour_number").innerHTML 	= 0;
		     //    document.getElementById("min_number").innerHTML 	= 0;
		     //    document.getElementById("sec_number").innerHTML 	= 0;

		     //    $("#sec").css("stroke-dashoffset", "35");
		     //    $("#min").css("stroke-dashoffset", "35");
		     //    $("#hour").css("stroke-dashoffset", "35");
		     //    $("#day").css("stroke-dashoffset", "35");
		     	//$('.wrapper-countdown').css('display', 'none')
		     	$('.detail-deal').css('display', 'none')
		    }

	    }, 1000);
  	}
	  
	  
	
	,collection_isotope: function(){
  		if (jQuery('.isotope-grid').length > 0) {
            if ('undefined' === typeof Isotope) {
                console.log(" Isotope has not defined yet! ");
                return;
            }

            var containerW = $('.col-main')
            var $grid = $('.isotope-grid').isotope({
                itemSelector: '.home-product-item',
            });

            // layout Isotope after each image loads
            // $grid.imagesLoaded().progress(function() {
            //     setTimeout(function() {
            //         $grid.isotope('layout');
            //     }, 2000)
            // });
        }
  	} 
	,smoothBody:function(bodyTop){
		if(!($('.header-main-wrapper div').hasClass('sticky-menu')))
		{
			if ($("#body-content").hasClass("has-header-fixed")) {	
				$(".has-header-fixed").css(
					{	
						"padding-top": bodyTop + "px"
					}
				)
			}		
			else{
				$("#body-content").removeAttr('style');
			}
		}
		// if ($("#body-content").hasClass("has-header-fixed")) {	
		// 	$(".has-header-fixed").css(
		// 		{	
		// 			"padding-top": bodyTop + "px"
		// 		}
		// 	)
		// }		
		// else{
		// 	$("#body-content").removeAttr('style');
		// }				
	}
 

  	,transparentText : function(){
		var tpText= jQuery('.heading-highlight'),
			tpTextTop= jQuery(tpText).offset().top,
			tpTextLeft= jQuery(tpText).offset().left,
			slideY= jQuery('.home-slideshow-wrapper').offset().top,
			slideX= jQuery('.home-slideshow-wrapper').offset().left,
			slideW= jQuery('.home-slideshow-wrapper').width(),
			slideH= jQuery('.home-slideshow-wrapper').height(),
			realOffsetTop= tpTextTop-slideY;
			realOffsetLeft= tpTextLeft-slideX;

			tpText.css(
				{
					"background-position": -realOffsetLeft + "px" + " " + -realOffsetTop + 'px',
					"background-size" : slideW + "px" + " " + slideH + "px"
				}
			)
	}

	,header4Sticky: function(page){
	    var headerMain = $('.header-main');
	    var bodyContent = $("#body-content");
	    var indexStickyMenu = $('.sticky-menu')
	    var height;
	   
	    $(window).on('scroll', function () {
	        height = headerMain.height();
	        if ($(this).scrollTop() >= height && $(window).width() > 992) {
	        	if(page == 'others') {
	        		headerMain.addClass('header-fixed fadeInDown animated');
	        	}
				else {
					indexStickyMenu.addClass('fadeInDown animated');
					indexStickyMenu.css('display','block');
				}
				bodyContent.addClass("has-header-fixed");
	        }
	        else if( ($(this).scrollTop() < height && $(window).width() > 992) ) {
	            if(page == 'others') {
	        		headerMain.removeClass('header-fixed fadeInDown animated');
	        	}
				else {
					indexStickyMenu.removeClass('fadeInDown animated');
					indexStickyMenu.css('display','none');
				}
	            bodyContent.removeClass("has-header-fixed");
	        }
	    })
	}

	,init : function(){
      
      	if( typeof _bc_config == 'undefined' ){
           	 console.log( " _bc_config is undefined " );
           	 return ;
        }
      
        this.stickMenu();
		this.toTopButton();
		this.mailchipPopup();
      	this.toggleCartSidebar();
      	this.toggleFOFSidebar();
      	this.toggleFilterSidebar();
		this.toggleFilterNoneSidebar();
      	this.parallaxIt();
      	this.handleGridList();
      	this.handleShowBy();
      	this.effectNavigation();
        this.fixButton();
		this.menuOnMobile();
		this.handleMenuMultiLine();
		this.fixTitle();
		this.filterCatalog();
        this.swatch();
      	this.switchImgProduct();
		this.refreshImage();
		this.refreshZoom();
		this.cartJS_handle();
      	//this.instagram_listener();
	}
}



/* Handle when window resize */
jQuery(window).resize(function() {
	
	/* reset menu with condition */
	if(AT_Main.getWidthBrowser() < 1024){
		if(jQuery('#top').hasClass('on')){
			jQuery('#top').prev().remove();
			jQuery('#top').removeClass('on').removeClass('animated');
		}
	}
    
    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');
          
});

jQuery(document).ready(function($) {
	
	AT_Main.init();
  	/* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
	}

	if(!($('body').hasClass('template-password'))){
		setTimeout(function(){
			var body= $('#body-content'),
			bodyTop= body.offset().top;
			$(window).scroll(function() {
				AT_Main.smoothBody(bodyTop);	
			});

			$(".size-chart #size-chart-popup").fancybox();	
			console.log('This is not template password')
		},800)
	}	

	if($('div').hasClass('detail-deal')){
		var content = $('.detail-deal').html();
		if (content == '')
		{
			$('.detail-deal').css('display', 'none')
		}	
	}
   
});

jQuery(window).load(function(){
	//add script tag for fixing scrolling bug on first load page
	var my_awesome_script = document.createElement('script');
	my_awesome_script.setAttribute('src',"//purlyair.myshopify.com/cdn/shop/t/11/assets/smooth-scroll.min.js?v=143991660184104895441600964770");
	document.head.appendChild(my_awesome_script);

	

})
                        
